// @flow
import * as React from 'react';
import { isEmpty } from 'lodash';
import ContentRow from 'esm-web-pro/components/layout/sidePanel/ContentRow';
import ValueText from 'esm-web-pro/components/layout/sidePanel/ValueText';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import { APIContext } from 'speed-js-react';
import RowActions from 'esm-web-pro/components/layout/sidePanel/RowActions';
import MeatballsIcon from 'esm-web-pro/components/layout/sidePanel/icons/MeatballsIcon';
import actionMessages from 'esm-web-pro/messages/actionMessages';
import { useHistory, useRouteMatch } from 'react-router';

type Props = {
    intl: IntlShape,
    container: Object,
    map: Object,
};

const AssetList = (props: Props) => {
    const {
        container, map: { uuid: mapUUID, is_draft: isDraft }, intl: { formatMessage },
    } = props;
    const { apiClient } = React.useContext(APIContext);
    const { uuid: containerId, type: containerType } = container;

    const [assets, setAssets] = React.useState([]);

    const match = useRouteMatch();
    const history = useHistory();

    React.useEffect(() => {
        const query = {};
        if (isDraft) {
            query.is_draft = mapUUID;
        }
        apiClient.resources[containerType].asset.list(container.uuid, query).then((response) => {
            setAssets(response.results);
        });
    }, [apiClient, containerType, container, mapUUID, isDraft]);

    const getActions = (asset) => ([
        {
            key: `asset-${asset.id}-more`,
            icon: <MeatballsIcon />,
            size: '20px',
            width: '3px',
            callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                const path = match.url.split('/layer');
                history.push(`${path[0]}/layer/asset/${asset.uuid}`);
            },
            tooltip: formatMessage(actionMessages.more),
        },
    ]);

    return !isEmpty(assets) ? assets.map((asset) => (
        <ContentRow
            key={asset.uuid}
            actions={<RowActions actions={getActions(asset)} />}
            rowId={`asset-${asset.uuid}`}
            hoverIndicator={null}
            padLevel={1}
        >
            <ValueText>
                {asset.ref}
            </ValueText>
        </ContentRow>
    )) : (
        <ContentRow padLevel={1}>
            <ValueText>
                <FormattedMessage id="no-assets" defaultMessage="No assests" />
            </ValueText>
        </ContentRow>
    );
};

export default injectIntl(AssetList);
